/** Read a declared slice, failing loudly if the loader did not provide it. */
export function required(slice, key) {
    const value = slice[key];
    if (value === undefined) {
        throw new Error(`Command slice "${key}" was not loaded — check the handler's needs declaration`);
    }
    return value;
}
//# sourceMappingURL=types.js.map